import { Option } from "components/parts/Input/SelectBox/SelectBox";

export type SubjectStatus =
  | "未アサイン"
  | "アサイン中"
  | "実施中"
  | "実施済"
  | "キャンセル";

export type InterviewStatus =
  | "未実施"
  | "入室待ち"
  | "入室済み"
  | "実施中"
  | "実施済"
  | "開始前キャンセル"
  | "開始後キャンセル"
  | "インタビュアー起因キャンセル"
  | "モニター起因キャンセル";

export type Status =
  | "NOT_ASSIGNED"
  | "ASSIGNING"
  | "DOING"
  | "DONE"
  | "CANCELED"
  | "FINISHED"
  | "NOT_STARTED"
  | "MONITOR_NOT_ENTERED"
  | "MONITOR_ENTERD"
  | "NOT_STARTED_CANCEL"
  | "STARTED_CANCEL"
  | "INTERVIEWER_CANCEL"
  | "MONITOR_CANCEL";

export const InterviewCanceledMapper = [
  "NOT_CANCELED",
  "NOT_STARTED_CANCEL",
  "STARTED_CANCEL",
  "INTERVIEWER_CANCEL",
  "MONITOR_CANCEL",
] as const;

export type InterviewCanceledType = (typeof InterviewCanceledMapper)[number];

export const InterviewCanceledMessageMapper: {
  [T in InterviewCanceledType]: string;
} = {
  NOT_CANCELED: "なし",
  NOT_STARTED_CANCEL: "開始前キャンセル",
  STARTED_CANCEL: "開始後キャンセル",
  INTERVIEWER_CANCEL: "インタビュアー起因キャンセル",
  MONITOR_CANCEL: "モニター起因キャンセル",
};

export type InterviewCancelProps = {
  label: string;
  value: number;
};
export const interviewPulldownList: Option[] = InterviewCanceledMapper.map(
  (item, index) => {
    return {
      value: index,
      text: Object.values(InterviewCanceledMessageMapper)[index],
    };
  }
);
